<template>
  <div class="feeDig">
<!--    <img :src="urlGet()" alt="">-->
  </div>
</template>

<script>
  import Viewer from 'viewerjs';
  import 'viewerjs/dist/viewer.css';
  import Vue from 'vue'
    export default {
        name: "imgIDDig",
      props: {

      },
      data(){
        return{
          viewer:null,
          choose:null
        }
      },
      mounted(){
      },
      methods:{
          newInstance(dom,isFullUrl){
            let _this = this
            this.viewer = null
            this.viewer = new Viewer(dom, { //keyboard为true 在凭证页面回合快捷键冲突
              viewed() {
              },
              keyboard:true,
              navbar:0,
              toolbar:{
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: 0,
                reset: 4,
                prev: 1,
                next: 1,
                play: {
                  show: 0,
                  size: 'large',
                },
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1,
              }
              // 相关配置项,详情见下面
            });
            if(isFullUrl){
              dom.children[0].click()
            }else{
              Array.prototype.find.call(dom.children, function(ele, index) {
                if(ele.id == _this.choose){
                  ele.click()
                  return true
                }else{
                  return false
                }
              })
            }

          },
          add(list,choose){
            this.choose = choose
            let dom = this.createDom(list)
            this.newInstance(dom)
          },
        addNormal(list,choose){
          this.choose = choose
          let dom = this.createDom(list,'normal')
          this.newInstance(dom)
        },
        createDom(imglist,type){
          let imgDomWrap = document.createElement('div')
          imglist.forEach(it=>{
            let imgDom = document.createElement('img')
            imgDom.src = type?this.urlGetNormal(it.id):this.urlGet(it.id)
            imgDom.id = it.id
            imgDomWrap.appendChild(imgDom)
          })
          return imgDomWrap
        },
        addFullURL(url){
          let imgDomWrap = document.createElement('div')
          let imgDom = document.createElement('img')
          imgDom.src = url
          imgDomWrap.appendChild(imgDom)
          this.newInstance(imgDomWrap,true)
        },
        urlGetNormal(id){
          if(!id) return;
          return Vue.axios.defaults.baseURL+'/file/fileProcessing/download?id='+id+'&access_token='+JSON.parse(Vue.axios.defaults.token);
        },
        urlGet(id){
          if(!id) return;
          return Vue.axios.defaults.baseURL+'/bill/download?id='+id+'&access_token='+JSON.parse(Vue.axios.defaults.token);
        },
      },
      destroyed() {
          this.viewer = null
      }
    }
</script>

<style scoped>

</style>
